<template lang="pug">
.card-body
  .card.card-warning
    .card-header.text-warning
      h4 {{ $t('ui.statement_info') }}
      .card-header-action
        a.btn.btn-icon.btn-info(data-collapse='#statement-collapse' href='#')
          i.fas.fa-minus
    #statement-collapse.collapse.show
      .card-body(v-if="member")
        .row
          .col-12.col-md-6.col-lg-3
            .card.card-primary
              .card-header
                h4
                  i.fas.fa-dollar-sign.mr-1
                  span.font-weight-bold(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                .card-header-action
                  span.badge.badge-info {{ currentMonth }}
                //-   i.fa.fa-lg.fa-info-circle.text-warning(:title="$t('ui.turnover')")
              .card-body                      
                .text-value
                  h3(:class="$helpers.fontClassName(validTurnover)" :title="$n(validTurnover, 'currency')") {{ $n(validTurnover, 'currency') }}
          .col-12.col-md-6.col-lg-3
            .card.card-info
              .card-header
                h4
                  i.fas.fa-money-bill-wave.mr-1
                  span.font-weight-bold(:title="$t('ui.winlose')") {{ $t("ui.winlose") }}
                .card-header-action
                  span.badge.badge-info {{ currentMonth }}
                  //- i.fa.fa-lg.fa-info-circle.text-warning(:title="$t('ui.winlose')")
              .card-body                    
                .text-value
                  h3(:class="$helpers.fontClassName(winlose)" :title="$n(winlose, 'currency')") {{ $n(winlose, 'currency') }}
          .col-12.col-md-6.col-lg-3
            .card.card-secondary
              .card-header
                h4
                  i.fas.fa-dollar-sign.mr-1
                  span.font-weight-bold(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
                  //- span.badge.badge-info.float-right {{ currentMonth }}
                //- .card-header-action
                //-   i.fa.fa-lg.fa-info-circle.text-warning(:title="$t('ui.total_deposit')")
              .card-body                      
                .text-value
                  h3(:class="$helpers.fontClassName(member.deposit_amount)" :title="$n(member.deposit_amount, 'currency')") {{ $n(member.deposit_amount, 'currency') }}
          .col-12.col-md-6.col-lg-3
            .card.card-warning
              .card-header
                h4
                  i.fas.fa-dollar-sign.mr-1
                  span.font-weight-bold(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
                  //- span.badge.badge-info.float-right {{ currentMonth }}
                //- .card-header-action
                //-   i.fa.fa-lg.fa-info-circle.text-warning(:title="$t('ui.withdrawal_amount')")
              .card-body                      
                .text-value
                  h3(:class="$helpers.fontClassName(member.withdrawal_amount)" :title="$n(member.withdrawal_amount, 'currency')") {{ $n(member.withdrawal_amount, 'currency') }}
          .col-12.col-md-6.col-lg-3
            .card.card-danger
              .card-header
                h4
                  i.fas.fa-dollar-sign.mr-1
                  span.font-weight-bold(:title="$tc('ui.ftd', 1)") {{ $tc('ui.ftd', 1) }}
                  //- span.badge.badge-info.float-right {{ currentMonth }}
                .card-header-action
                  i.fa.fa-lg.fa-info-circle.text-warning(:title="$tc('ui.ftd', 2)")
              .card-body                      
                .text-value
                  h3(:class="$helpers.fontClassName(ftdAmount)" :title="$n(ftdAmount, 'currency')") {{ $n(ftdAmount, 'currency') }}

          .col-12.col-md-6.col-lg-3
            .card.card-primary
              .card-header
                h4
                  i.fas.fa-money-bill.mr-1
                  span.font-weight-bold(:title="$t('ui.free_credit_withdrawal_amount')") {{ $t('ui.fc_withdrawal_amount') }}
                .card-header-action
                  i.fa.fa-lg.fa-info-circle.text-warning(:title="$t('ui.free_credit_withdrawal_amount')")
              .card-body
                .text-value
                  h3(:class="$helpers.fontClassName(member.withdrawal_amount_free)" :title="$n(member.withdrawal_amount_free, 'currency')") {{ $n(member.withdrawal_amount_free, 'currency') }}
      
          .col-12.col-md-12.col-lg-12
            b-form-group(:label="$t('ui.deposit')")
              ul#operatortab.nav.nav-tabs(role='tablist')
                li.nav-item(@click="firstVTab = 'normal'")
                  a#normal-tab.nav-link(:class="{ active: firstVTab === 'normal' }" data-toggle='tab' href='#normal-content' role='tab' aria-controls='normal' aria-selected='false') {{ $t("ui.normal") }}
                li.nav-item(@click="firstVTab = 'voucher'")
                  a#voucher-tab.nav-link(:class="{ active: firstVTab === 'voucher' }" data-toggle='tab' href='#voucher-content' role='tab' aria-controls='voucher' aria-selected='false') {{ $t("ui.voucher") }}
              .tab-content.tab-bordered
                #normal-content.tab-pane.fade(:class="{ active: firstVTab === 'normal', show: firstVTab === 'normal' }" role='tabpanel' aria-labelledby='normal-tab')
                  .clusterize-scroll
                    .table-responsive
                      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                        thead.thead-light
                          tr
                            th(width="15%")
                              span(:title="$t('ui.date')") {{ $t("ui.date") }}
                            th.text-right(width="10%")
                              span(:title="$t('ui.deposit')") {{ $t("ui.deposit") }}
                            th.text-right(width="10%")
                              span(:title="$t('ui.bonus')") {{ $t("ui.bonus") }}
                            th(width="10%")
                              span(:title="$t('ui.ticket_id')") {{ $t("ui.ticket_id") }}
                            th(width="10%")
                              span(:title="$t('ui.mode')") {{ $t("ui.mode") }}
                            th(width="15%")
                              span(:title="$t('ui.payment_gateway')") {{ $t("ui.payment_gateway") }}
                            th(width="10%")
                              span(:title="$t('ui.promo_id')") {{ $t("ui.promo_id") }}
                            th(width="20%")
                              span(:title="$t('ui.promo_name')") {{ $t("ui.promo_name") }}
                        tbody
                          tr(v-if="depositList.length == 0")
                            td(colspan="8").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in depositList")
                            td
                              span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                            td
                              span(:title="item.ticket_id") {{ item.ticket_id }}
                            td
                              span(:title="item.payment_option") {{ item.payment_option }}
                            td
                              span(:title="item.payment_gateway") {{ item.payment_gateway }}
                            td
                              span(:title="item.promotion_id") {{ item.promotion_id }}
                            td
                              span(:title="item.promotion_name") {{ item.promotion_name }}
                #voucher-content.tab-pane.fade(:class="{ active: firstVTab === 'voucher', show: firstVTab === 'voucher' }" role='tabpanel' aria-labelledby='voucher-tab')
                  .clusterize-scroll
                    .table-responsive
                      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                        thead.thead-light
                          tr
                            th(width="15%")
                              span(:title="$t('ui.date')") {{ $t("ui.date") }}
                            th.text-right(width="10%")
                              span(:title="$t('ui.deposit')") {{ $t("ui.deposit") }}
                            th.text-right(width="10%")
                              span(:title="$t('ui.bonus')") {{ $t("ui.bonus") }}
                            th(width="10%")
                              span(:title="$t('ui.ticket_id')") {{ $t("ui.ticket_id") }}
                            th(width="10%")
                              span(:title="$t('ui.mode')") {{ $t("ui.mode") }}
                            th(width="15%")
                              span(:title="$t('ui.payment_gateway')") {{ $t("ui.payment_gateway") }}
                            th(width="10%")
                              span(:title="$t('ui.promo_id')") {{ $t("ui.promo_id") }}
                            th(width="20%")
                              span(:title="$t('ui.promo_name')") {{ $t("ui.promo_name") }}
                        tbody
                          tr(v-if="voucherDepositList.length == 0")
                            td(colspan="8").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in voucherDepositList")
                            td
                              span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                            td
                              span(:title="item.ticket_id") {{ item.ticket_id }}
                            td
                              span(:title="item.payment_option") {{ item.payment_option }}
                            td
                              span(:title="item.payment_gateway") {{ item.payment_gateway }}
                            td
                              span(:title="item.promotion_id") {{ item.promotion_id }}
                            td
                              span(:title="item.promotion_name") {{ item.promotion_name }}
          .col-sm-12.col-md-6.col-lg-6
            b-form-group(:label="$t('ui.withdrawal')")
              .clusterize-scroll
                .table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      th(width="45%")
                        span(:title="$t('ui.date')") {{ $t("ui.date") }}
                      th.text-right(width="55%")
                        span(:title="$t('ui.withdrawal')") {{ $t("ui.withdrawal") }}
                    tbody
                      tr(v-if="withdrawalList.length == 0")
                        td(colspan="2").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in withdrawalList")
                        td
                          span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
          .col-sm-12.col-md-6.col-lg-6
            b-form-group(:label="$t('ui.login')")
              .clusterize-scroll
                .table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th(width="20%")
                          span(:title="$t('ui.date')") {{ $t("ui.date") }}
                        th(width="40%")
                          span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                        th(width="30%")
                          span(:title="$t('ui.browser_agent')") {{ $t("ui.browser_agent") }}
                    tbody
                      tr(v-if="loginList.length == 0")
                        td(colspan="3").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in loginList")
                        td
                          span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td
                          span(:title="item.login_ip") {{ item.login_ip }}
                        td
                          span(:title="item.browser_agent") {{ item.browser_agent }}
          .col-12.col-md-12.col-lg-12
            b-form-group(:label="$t('ui.wallet_history')")
              .clusterize-scroll
                .table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th(width="10%")
                          span(:title="$t('ui.date')") {{ $t("ui.date") }}
                        th(width="10%")
                          span(:title="$t('ui.type')") {{ $t("ui.type") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.amount')") {{ $t("ui.amount") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.balance_before')") {{ $t("ui.balance_before") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.balance_after')") {{ $t("ui.balance_after") }}
                        th(width="30%")
                          span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                    tbody
                      tr(v-if="historyList.length == 0")
                        td(colspan="8").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in historyList")
                        td
                          span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td
                          span(:title="item.action_type") {{ item.action_type }}
                        td.text-right
                          template(v-if="['DEPOSIT','WITHDRAWAL'].includes(item.action_type)")
                            a.text-decoration-none(href="javascript:void(0)" @click="getTicketDetail(item)")
                              span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="showTicketDetails(item)") {{ $n(item.amount, 'currency') }}
                          template(v-else)
                            span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')" ) {{ $n(item.amount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.balance_before)" :title="$n(item.balance_before, 'currency')") {{ $n(item.balance_before, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.balance_after)" :title="$n(item.balance_after, 'currency')") {{ $n(item.balance_after, 'currency') }}
                        td
                          span(:title="item.remark") {{ item.remark }}
  .card.card-primary
    .card-header.text-primary
      h4 {{ $t('ui.member_detail') }}
      .card-header-action
        a.btn.btn-icon.btn-info(data-collapse='#details-collapse' href='#')
          i.fas.fa-minus
    #details-collapse.collapse.show
      .card-body(v-if="member")
        .row.ml-1
          div(v-if="showActionButton('edit')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-edit"
              :text="$t('ui.edit')"
              type="button"
              @click="onEdit(member)"
              variant="primary"
              size="sm"
              )
          div(v-if="showActionButton('resetpassword')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-lock"
              :text="$t('ui.reset_password')"
              type="button"
              @click="onResetPasswordMember(member)"
              variant="warning"
              size="sm"
              )
          //- div(v-if="showActionButton('updatememberbetlimit')").mr-2.mb-1
          //-   SubmitButton(
          //-     :loading="loading"
          //-     icon="fa fa-gamepad"
          //-     :text="$t('ui.update_member_bet_limit')"
          //-     type="button"
          //-     @click="onUpdateMemberBetLimit(member)"
          //-     variant="info"
          //-     size="sm"
          //-   )
          div(v-if="member.status.toUpperCase() == 'ACTIVE' && showActionButton('raisedepositticket')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-list-alt"
              :text="$t('ui.raise_deposit_ticket')"
              type="button"
              @click="onRaiseDepositTicket(member)"
              variant="success"
              size="sm"
            )
          div(v-if="member.status.toUpperCase() == 'ACTIVE' && showActionButton('raisedepositticket')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-list-alt"
              :text="$t('ui.raise_deposit_ticket_gateway')"
              type="button"
              @click="onRaiseDepositTicketGateway(member)"
              variant="primary"
              size="sm"
            )
          div(v-if="member.status.toUpperCase() == 'ACTIVE' && showActionButton('raisedepositticketvoucher')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-list-alt"
              :text="$t('ui.raise_deposit_ticket_voucher')"
              type="button"
              @click="onRaiseDepositTicketVoucher(member)"
              variant="warning"
              size="sm"
            )
          div(v-if="member.status.toUpperCase() == 'ACTIVE' && showActionButton('raisedepositticketvoucher')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-list-alt"
              :text="$t('ui.raise_deposit_ticket_voucher_gateway')"
              type="button"
              @click="onRaiseDepositTicketVoucherGateway(member)"
              variant="info"
              size="sm"
            )
          div(v-if="showActionButton('adjustbalance')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-sliders-h"
              :text="$t('ui.adjust_balance')"
              type="button"
              @click="onAdjust(member)"
              variant="danger"
              size="sm"
            )
          div(v-if="showActionButton('adjustvoucherbalance')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-sliders-h"
              :text="$t('ui.adjust_voucher_balance')"
              type="button"
              @click="onAdjustVoucherBalance(member)"
              variant="warning"
              size="sm"
            )
          //- div(v-if="showActionButton('adjustfreebalance')").mr-2.mb-1
          //-   SubmitButton(
          //-     :loading="loading"
          //-     icon="fa fa-sliders-h"
          //-     :text="$t('ui.adjust_free_balance')"
          //-     type="button"
          //-     @click="onFreeAdjust(member)"
          //-     variant="danger"
          //-     size="sm"
          //-   )
          div(v-if="showActionButton('addpromotion')").mr-3.mb-2
            SubmitButton(
              :loading="loading"
              icon="fa fa-gift"
              :text="$t('ui.correction_promo')"
              type="button"
              @click="onPromoMemberAssign(member)"
              variant="info"
              size="sm"
              ) 
          div(v-if="showActionButton('e_promomemberfree')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-sliders-h"
              :text="$t('ui.combine.free_credit_manual_assign')"
              type="button"
              @click="onFreeCreditManualAssign(member)"
              variant="primary"
              size="sm"
            )
          div(v-if="showActionButton('bonusissue')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-money-bill-alt"
              :text="$t('ui.bonus_issue')"
              type="button"
              @click="onBonusIssue(member)"
              variant="primary"
              size="sm"
              )
          div(v-if="showActionButton('updatevip')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-crown"
              :text="$t('ui.update_vip')"
              type="button"
              @click="onUpdateVip(member)"
              variant="warning"
              size="sm"
            )
          div(v-if="showActionButton('gettac') && !member.account_verified").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-mobile-alt"
              :text="$t('ui.get_tac')"
              type="button"
              @click="onGetTac(member)"
              variant="success"
              size="sm"
            )
          div(v-if="showActionButton('getbanktac')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-building"
              :text="$t('ui.get_bank_tac')"
              type="button"
              @click="onGetBankTac(member)"
              variant="info"
              size="sm"
            )
          div(v-if="showActionButton('inboxlist')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-envelope"
              :text="$t('ui.get_inbox')"
              type="button"
              @click="onGetInbox(member)"
              variant="success"
              size="sm"
            )
          div(v-if="showActionButton('freecredit')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-credit-card"
              :text="$t('ui.free_credit')"
              type="button"
              @click="onPromoSignupAssign(member)"
              variant="danger"
              size="sm"
            )
          div(v-if="showActionButton('freegametoken')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-sliders-h"
              :text="$t('ui.free_game_token')"
              type="button"
              @click="onFreeGameToken(member)"
              variant="primary"
              size="sm"
            )
          div(v-if="showActionButton('ftprovider') && fundTransferEnable").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-sliders-h"
              :text="$t('ui.fund_transfer_provider')"
              type="button"
              @click="onFTProvider(member)"
              variant="warning"
              size="sm"
            )
          div(v-if="showActionButton('voucherlist')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-list-alt"
              :text="$t('ui.get_voucher')"
              type="button"
              @click="onGetVoucher(member)"
              variant="info"
              size="sm"
            )
          div(v-if="showActionButton('messagelist')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-comments"
              :text="$t('ui.get_message')"
              type="button"
              @click="onGetMessage(member)"
              variant="success"
              size="sm"
            )
          div(v-if="showActionButton('issuefreespin')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-dice"
              :text="$t('ui.issue_free_spin')"
              type="button"
              @click="onIssueFreeSpin(member)"
              variant="primary"
              size="sm"
              )
          div(v-if="showActionButton('checkfreespin')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fas fa-gamepad"
              :text="$t('ui.check_free_spin')"
              type="button"
              @click="onCheckMemberFreeSpin(member)"
              variant="warning"
              size="sm"
              )
          div(v-if="showActionButton('clearfreebalance')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-eraser"
              :text="$t('ui.clear_free_credit')"
              type="button"
              @click="onClearFreeCredit(member)"
              variant="danger"
              size="sm"
            )
          div(v-if="member.status.toUpperCase() == 'BLOCK' && showActionButton('unblock')").mr-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-unlock"
              :text="$t('ui.unblock')"
              type="button"
              @click="onUnblock(member)"
              variant="info"
              size="sm"
            )
          
        .row.mt-2
          .col-sm-4.col-md-4.col-lg-4
            b-form-group
              .table-responsive
                table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                  thead.thead-light
                    tr
                      th(colspan="2")
                        span  {{ $t("ui.member") }}
                  tbody(v-if="member")
                    tr
                      td
                        span {{ $t("ui.member_id") }}
                      td
                        span {{ member.account_id }}
                    tr
                      td
                        span {{ $t("ui.second_id") }}
                      td
                        span {{ member.second_id }}
                    tr
                      td
                        span {{ $t("ui.contact_phone") }}
                      td
                        span {{ member.contact_phone }}
                    tr
                      td
                        span {{ $t("ui.signup_ip") }}
                      td
                        span {{ member.signup_ip }}
                    tr
                      td
                        span {{ $t("ui.login_ip") }}
                      td
                        b-link(v-if="showActionButton('memberloginlog')" href="javascript:void(0);" @click="jumpToLoginLog(member.last_login_ip)") {{ member.last_login_ip }}
                        span(v-else) {{ member.last_login_ip }}
                    tr
                      td
                        span {{ $t("ui.balance") }}
                      td
                        template(v-if="wallet != null")
                          span(:title="wallet.game_balance") {{ wallet.game_balance }}
                          span.ml-1(v-if="wallet.outstanding_balance != 0 && wallet.outstanding_balance != null")
                            template(v-if="showActionButton('clearoutstanding') == true")
                              //- template(v-if="isOperator")
                              //-   span.font-weight-bold(:class="{'text-danger': wallet.outstanding_balance < 0  }") ({{ $n(wallet.outstanding_balance, 'currency') }})
                              //- template(v-else)
                              b-link.font-weight-bold.text-decoration-none(href="javascript:void(0);" @click="onClearOutstanding(member)" :class="{'text-danger': wallet.outstanding_balance < 0  }") ({{ $n(wallet.outstanding_balance, 'currency') }})
                            template(v-else)
                              span(:class="{'text-danger': wallet.outstanding_balance < 0  }" :title="$n(wallet.outstanding_balance, 'currency')") ({{ $n(wallet.outstanding_balance, 'currency') }})
                        template(v-else)
                          span 0
                        //-   span.ml-1(v-if="wallet.outstanding_balance != 0 && wallet.outstanding_balance != null && showActionButton('clearoutstanding') == true" :title="$n(wallet.outstanding_balance, 'currency')")
                        //-     template(v-if="isOperator")
                        //-       span.font-weight-bold(:class="{'text-danger': wallet.outstanding_balance < 0  }") ({{ $n(wallet.outstanding_balance, 'currency') }})
                        //-     template(v-else)
                        //-       b-link.font-weight-bold.text-decoration-none(href="javascript:void(0);" @click="onClearOutstanding(member)" :class="{'text-danger': wallet.outstanding_balance < 0  }") ({{ $n(wallet.outstanding_balance, 'currency') }})
                        //-   span(:class="{'text-danger': wallet.outstanding_balance < 0  }" v-if="wallet.outstanding_balance != 0 && wallet.outstanding_balance != null && showActionButton('clearoutstanding') == false" :title="$n(wallet.outstanding_balance, 'currency')") ({{ $n(wallet.outstanding_balance, 'currency') }})
                        //- template(v-else)
                        //-   span 0
                    tr
                      td
                        span {{ $t("ui.token_balance") }}
                      td
                        span(:title="$n(member.token_balance, 'currency')") {{ $n(member.token_balance, 'currency') }}
                    tr
                      //- td
                      //-   span {{ $t("ui.cash_balance") }}
                      //-   i.fa.fa-lg.fa-info-circle.text-info.fa-sm.ml-2(data-toggle="tooltip" :title="$t('ui.free_game_provider')")
                      //- td
                      //-   span(:title="$n(cashBalance, 'currency')") {{ $n(cashBalance, 'currency') }}
                    tr
                      td
                        span {{ $t("ui.free_balance") }}
                        i.fa.fa-lg.fa-info-circle.text-info.fa-sm.ml-2(data-toggle="tooltip" :title="$t('ui.free_game_provider')")
                      td
                        span(:title="$n(gameBalance, 'currency')") {{ $n(gameBalance, 'currency') }}
                    tr
                      td
                        span {{ $t("ui.voucher_balance") }}
                      td
                        span(:title="$n(voucherBalance, 'currency')") {{ $n(voucherBalance, 'currency') }}
                    tr
                      td
                        span {{ $t("ui.referral_code") }}
                      td
                        b-link(v-if="showActionButton('refereelist')" href="javascript:void(0);" @click="jumpToRLReport()") {{ member.referral_code }}
                        span(v-else) {{ member.referral_code }}
                    tr
                      td
                        span {{ $t("ui.upline") }}
                      td
                        span {{ member.referrer_id }}
                    tr
                      td
                        span {{ $t("ui.created_date") }}
                      td
                        span(:title="$moment(member.created_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="member.created_date") {{ $moment(member.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    tr
                      td
                        span {{ $t("ui.verified_date") }}
                      td
                        span(:title="$moment(member.verified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="member.verified_date") {{ $moment(member.verified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    tr
                      td
                        span {{ $t("ui.downline") }}
                      td
                        span.font-weight-bold(v-if="member.referee_count_confirm != 0 && showActionButton('refereelist')")
                          //- b-link(href="javascript:void(0);" @click="redirectToRL(member)" :title="$n(member.referee_count_confirm, 'integer')") {{ $n(member.referee_count_confirm, 'integer') }}
                          b-link.text-decoration-none(href="javascript:void(0);" @click="jumpToRLReport()" :title="$n(member.referee_count_confirm, 'integer') + ' ' + $t('ui.verified')") {{ $n(member.referee_count_confirm, 'integer') }} 
                          span / {{ $n(member.referee_count_total, 'integer') }}
                        span.font-weight-bold(v-else :title="$n(member.referee_count_confirm, 'integer')") {{ $n(member.referee_count_confirm, 'integer') }}
                    tr
                      td
                        span {{ $t("ui.status") }}
                      td
                        template(v-if="isEditAccess")
                          span(v-if="member.status.toUpperCase() == 'FREEZE' || member.status.toUpperCase() == 'BLOCK'" :title="member.status") {{ member.status }}
                          b-form-select(@change="changedMemberStatus(member, $event)" v-model="member.status" size="sm" v-else)
                            option(value="ACTIVE") {{ $t("ui.active") }}
                            option(value="CLOSE") {{ $t("ui.close") }}
                            option(value="SUSPEND") {{ $t("ui.suspend") }}
                        template(v-else)
                          span(:title="member.status" :class="$helpers.badgeClass(member.status)") {{ member.status }}
                    tr
                      td
                        span {{ $t("ui.affiliate") }}
                      td
                        span {{ member.affiliate_id }}
                    tr
                      td
                        span {{ $t("ui.remark") }}
                      td
                        span(style="white-space: initial;!important") {{ member.remark }}
            //- b-form-group
            //-   .table-responsive
            //-     table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            //-       thead.thead-light
            //-         tr
            //-           th
            //-             span  {{ $t("ui.label") }}
            //-           th.text-right
            //-             span(v-if="isEditAccess")
            //-               a.fa.fa-lg.fa-edit.text-primary(href="javascript:void(0)" @click="onUpsertLabel(member)" :title="$t('ui.edit')")
            //-       tbody
            //-         tr
            //-           td(colspan="2")
            //-             template(v-if="memberLabel")
            //-               span.badge.badge-info.align-middle(v-for="obj in memberLabel.split(',').sort()" style="width: auto;") {{ obj }}
          .col-sm-4.col-md-4.col-lg-4
            b-form-group
              .table-responsive
                table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                  thead.thead-light
                    tr
                      th(colspan="2")
                        span {{ $t("ui.promotion") }}
                  tbody
                    tr
                      td
                        span {{ $t("ui.promo") }}
                      td
                        span {{ promoID }}
                    tr
                      td
                        span {{ $t("ui.bonus_name") }}
                      td
                        span {{ bonusName }}
                    tr
                      td
                        span {{ $t("ui.bonus_amount") }}
                      td
                        span {{ $n(bonusAmount, 'currency') }}
                    //- tr
                    //-   td
                    //-     span {{ $t("ui.bonus_amount") }}
                    //-   td
                    //-     span {{ $n(bonusAmount, 'currency') }}
                    tr
                      td
                        span {{ $t("ui.created_date") }}
                      td
                        span(v-if="promoDate") {{ $moment(promoDate).format('YYYY-MM-DD, HH:mm:ss') }}
                    tr
                      td
                        span {{ $t("ui.criteria") }}
                      td
                        span {{ promoCriteria }}
                    tr(v-if="promoInbox")
                      td
                        span {{ $t("ui." + inboxLabel) }}
                      td
                        span {{ promoInbox }}
                    tr(v-if="promoCampaign")
                      td
                        span {{ $t("ui." + campaignLabel) }}
                      td
                        span {{ promoCampaign }}
                    tr(v-if="voucherId")
                      td
                        span {{ $t("ui." + voucherIdLabel) }}
                      td
                        span {{ voucherId }}
                    tr(v-if="voucherCash")
                      td
                        span {{ $t("ui." + voucherCashLabel) }}
                      td
                        span {{ $n(voucherCash, 'currency') }}
                    tr(v-if="promoRemark")
                      td
                        span {{ $t("ui.remark") }}
                      td
                        span {{ promoRemark }}
                span.ml-1.font-weight-bold {{ promoID }} ({{ $n(promoAccumulate, 'currency') }}/{{ $n(promoTarget, 'currency') }})
                b-progress(:max="promoTarget" height="1.5rem" show-progress animated style="border-style: solid;border-radius: 10px;")
                  b-progress-bar(v-if="promoAccumulate < promoTarget" :value='promoAccumulate' variant="success" :label='`${((promoAccumulate / promoTarget) * 100).toFixed(2)}%`')
                  b-progress-bar(v-else :value='promoAccumulate' variant="success" label='100.00%')
            
            b-form-group.mt-3
              .table-responsive
                table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                  thead.thead-light
                    tr
                      th
                        span  {{ $t("ui.label") }}
                      th.text-right
                        span(v-if="isEditAccess")
                          a.fa.fa-lg.fa-edit.text-primary(href="javascript:void(0)" @click="onUpsertLabel(member)" :title="$t('ui.edit')")
                  tbody
                    tr
                      td(colspan="2")
                        template(v-if="memberLabel")
                          span.badge.badge-info.align-middle(v-for="obj in memberLabel.split(',').sort()" style="width: auto;") {{ obj }} 
              
            b-form-group.mt-3(v-if="isUat == 'true' || ['MYR'].includes(getCurrencyCode)")
              .table-responsive
                table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                  thead.thead-light
                    tr
                      th(width="34%")
                        span  {{ $t("ui.game_provider") }}
                      th(width="33%")
                        span  {{ $t("ui.id") }}
                      th(width="33%")
                        span {{ $t("ui.password") }}
                  tbody
                    tr
                      td
                        span 918
                      td
                        span(:title="member['918']") {{ member['918'] }}
                      td
                        span &nbsp;
                        //- span(:title="member['918_password']") {{ member['918_password'] }}
                    tr
                      td
                        span MEGA
                      td
                        span(:title="member.mega") {{ member.mega }}
                      td
                        span &nbsp;
                    //- tr
                    //-   td
                    //-     span PUSSY(H5)
                    //-   td
                    //-     span(:title="member.pussy") {{ member.pussy }}
                    //-   td
                    //-     //- span(:title="member.pussy_password") {{ member.pussy_password }}
                    tr
                      td
                        span PUSSY(APP)
                      td
                        span(:title="member.pussy_app") {{ member.pussy_app }}
                      td
                        span(:title="member.pussy_app_password") {{ member.pussy_app_password }}

          .col-sm-4.col-md-4.col-lg-4
            b-form-group
              .table-responsive
                table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                  thead.thead-light
                    tr
                      th(colspan="2")
                        span  {{ $t("ui.vip") }}
                  tbody
                    tr
                      td(width="50%")
                        span {{ $t("ui.current_level") }}
                      td(width="50%")
                        span {{ currentVip }}
                    tr
                      td
                        span {{ $t("ui.next_level") }}
                      td
                        span {{ nextVip }}
                    tr
                      td
                        span {{ $t("ui.possible_next_level") }}
                      td
                        span {{ possibleNextVip }}
                    tr
                      td
                        span {{ $t("ui.cycle") }}
                      td
                        span {{ lastCycle ? $moment(lastCycle).format('YYYY-MM-DD') : null }} - {{ nextCycle ? $moment(nextCycle).format('YYYY-MM-DD') : null }}
                template(v-if="vipDepositTarget > 0")
                  span.ml-1.font-weight-bold {{ $t("ui.deposit") }} ({{ $n(vipDepositAcc, 'currency') }}/{{ $n(vipDepositTarget, 'currency') }})
                  b-progress(:max="vipDepositTarget" height="1.5rem" show-progress animated style="border-style: solid;border-radius: 10px;")
                    b-progress-bar(v-if="vipDepositAcc < vipDepositTarget" :value='vipDepositAcc' variant="info" :label='`${((vipDepositAcc / vipDepositTarget) * 100).toFixed(2)}%`')
                    b-progress-bar(v-else :value='vipDepositTarget' variant="success" label='100.00%')
                template(v-if="vipTurnoverTarget > 0")
                  span.ml-1.font-weight-bold {{ $t("ui.turnover") }} ({{ $n(vipTurnoverAcc, 'currency') }}/{{ $n(vipTurnoverTarget, 'currency') }})
                  b-progress(:max="vipTurnoverTarget" height="1.5rem" show-progress animated style="border-style: solid;border-radius: 10px;")
                    b-progress-bar(v-if="vipTurnoverAcc < vipTurnoverTarget" :value='vipTurnoverAcc' variant="warning" :label='`${((vipTurnoverAcc / vipTurnoverTarget) * 100).toFixed(2)}%`')
                    b-progress-bar(v-else :value='vipTurnoverTarget' variant="success" label='100.00%')
        
            b-form-group.mt-3
              .table-responsive
                table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                  thead.thead-light
                    tr
                      th(colspan="2")
                        span  {{ $t("ui.login_streak") }}
                  tbody
                    tr
                      td
                        span {{ $t("ui.cycle") }}
                      td
                        span {{ cycleDay }}
                    tr
                      td
                        span {{ $t("ui.status") }}
                      td
                        span.badge(:class="{'badge-success': cycleStatus, 'badge-danger': !cycleStatus  }") {{ cycleStatus ? $t("ui.active").toUpperCase() : $t("ui.inactive").toUpperCase() }}
                    tr
                      td
                        span {{ $t("ui.current_streak") }}
                      td
                        span {{ member.current_streak }}
                    tr
                      td
                        span {{ $t("ui.last_login") }}
                      td
                        span(:title="$moment(member.last_login_time).format('YYYY-MM-DD')") {{ member.last_login_time ? $moment(member.last_login_time).format('YYYY-MM-DD') : member.last_login_time }}
        .row
          .col-sm-12.col-md-12.col-lg-12
            b-form-group(:label="$tc('ui.banks', 2)")
              .clusterize-scroll.table-responsive
                table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                  thead.thead-light
                    tr
                      th.text-center(width="3%")
                        span #
                      th(width="7%")
                        span(:title="$t('ui.bank_id')") {{ $t("ui.bank_id") }}
                      th(width="15%")
                        span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                      th(width="20%")
                        span(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
                      th(width="10%")
                        span(:title="$t('ui.category')") {{ $t("ui.category") }}
                      template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                        th.text-left(width="10%")
                          span(:title="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')") {{ ['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit') }}
                        th.text-left(width="10%" v-if="['AUD'].includes(getCurrencyCode)")
                          span(:title="$t('ui.payid')") {{ $t("ui.payid") }}
                      th.text-center(width="10%")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}                      
                      th(width="15%")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  tbody
                    tr(v-if="bankList.length == 0")
                      td(colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in bankList")
                      td.text-center(width="5%")
                        span(:title="index + 1") {{ index + 1 }}
                      td
                        span(:title="item.bank_id") {{ item.bank_id }}
                      td
                        span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                      td
                        span(:title="item.bank_acc_holder") {{ item.bank_acc_holder }}
                      td
                        span(:title="item.category") {{ item.category }}
                      template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                        td
                          span(:title="item.remark") {{ item.remark }}
                        td(v-if="['AUD'].includes(getCurrencyCode)")
                          span(:title="item.remark_2") {{ item.remark_2 }}
                      td.text-center
                        span(v-if="isOperator")
                          i(:class="{'fas fa-check text-info': item.status, 'fas fa-times text-warning': !item.status  }")
                        div.d-flex.justify-content-center.align-items-center(v-else)
                          label.custom-switch
                            input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="changedBankMbmStatus(item, $event)")
                            //- input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" disabled)
                            span.custom-switch-indicator                      
                      td
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

  .card.card-secondary(v-show="member && member.account_verified == 1 && showHideTab('report')")
    .card-header.text-dark
      h4 {{ $t('ui.memberreport') }}
      .card-header-action
        a.btn.btn-icon.btn-info(data-collapse='#report-collapse' href='#')
          i.fas.fa-minus
    #report-collapse.collapse.show
      .card-body
        memberReportContainer.mt-2#memberReportContainer(ref="memberReportContainer" :operatorID="operatorID" :memberID="memberID" :member="member")

  .card.card-info(v-show="member && member.account_verified == 1 && showHideTab('log')")
    .card-header.text-info
      h4 {{ $t('ui.member_log') }}
      .card-header-action
        a.btn.btn-icon.btn-info(data-collapse='#log-collapse' href='#')
          i.fas.fa-minus
    #log-collapse.collapse.show
      .card-body
        memberLogContainer.mt-2#memberLogContainer(ref="memberLogContainer" :operatorID="operatorID" :memberID="memberID" :member="member")

  //- updatememberbetlimit(ref="updatememberbetlimit" :item="editSelectedMember" @clicked="afterUpdateMemberBetLimit" @failed="handleFailed")
  raisedepositticket(ref="raisedepositticket" :item="editSelectedMember" @clicked="afterRaiseDepositTicket" @failed="handleFailed")
  raisedepositticketgateway(ref="raisedepositticketgateway" :item="editSelectedMember" @clicked="afterRaiseDepositTicketGateway" @failed="handleFailed")
  getinboxlist(ref="getinboxlist" :item="editSelectedMember" @failed="handleFailed")
  adjustmember(ref="adjustmember" :item="editSelectedMember" @clicked="afterAdjustMember" @failed="handleFailed")
  adjustvoucherbalance(ref="adjustvoucherbalance" :item="editSelectedMember" @clicked="afterAdjustVoucherBalance" @failed="handleFailed")
  freegametoken(ref="freegametoken" :item="editSelectedMember" @clicked="afterFreeGameToken" @failed="handleFailed")
  upsertlabel(ref="upsertlabel" :item="editSelectedMember" @clicked="afterUpsertLabel" @failed="handleFailed")
  bonusissue(ref="bonusissue" :item="editSelectedMember" @clicked="afterIssueBonus" @failed="handleFailed")
  editmember(ref="editmember" :item="editSelectedMember" @clicked="afterEditMember" @failed="handleFailed")
  gettac(ref="gettac" :item="editSelectedMember" @failed="handleFailed")
  getbanktac(ref="getbanktac" :item="editSelectedMember" @failed="handleFailed")
  updatevip(ref="updatevip" :item="editSelectedMember" @clicked="afterUpdateVip" @failed="handleFailed")
  promomemberassign(ref="promomemberassign" :item="editSelectedMember" @clicked="afterPromoMemberAssign" @failed="handleFailed")
  resetpasswordmember(ref="resetpasswordmember" :item="editSelectedMember" @clicked="afterResetPasswordMember" @failed="handleFailed")
  clearoutstanding(ref="clearoutstanding" :item="editSelectedMember" @clicked="afterClearOutstanding" @failed="handleFailed")

  ticketdetail(ref="ticketdetail" :ticketId="selectedTicketId" @failed="handleFailed")
  adjustfreebalance(ref="adjustfreebalance" :item="editSelectedMember" :balance="gameBalance" @clicked="afterAdjustMember" @failed="handleFailed")
  fundtransferprovider(ref="fundtransferprovider" :item="editSelectedMember" @clicked="afterFTProvider" @failed="handleFailed")
  raisedepositticketvoucher(ref="raisedepositticketvoucher" :item="editSelectedMember" @clicked="afterRaiseDepositTicketVoucher" @failed="handleFailed")
  raisedepositticketvouchergateway(ref="raisedepositticketvouchergateway" :item="editSelectedMember" @clicked="afterRaiseDepositTicketVoucherGateway" @failed="handleFailed")
  getvoucherlist(ref="getvoucherlist" :item="editSelectedMember" @failed="handleFailed")
  getmessagelist(ref="getmessagelist" :item="editSelectedMember" @failed="handleFailed")
  freecreditmanualassign(ref="freecreditmanualassign" :item="editSelectedMember" @clicked="afterFreeCreditManualAssign" @failed="handleFailed")
  issuefreespin(ref="issuefreespin" :item="editSelectedMember" @clicked="afterIssueFreeSpin" @failed="handleFailed")
  checkmemberfreespin(ref="checkmemberfreespin" :item="editSelectedMember" @failed="handleFailed")
  clearfreecredit(ref="clearfreecredit" :item="editSelectedMember" @clicked="afterClearFreeCredit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
// import updatememberbetlimit from "@/components/member/updateMemberBetLimit.vue";
import raisedepositticket from "@/components/member/raiseDepositTicket.vue";
import raisedepositticketgateway from "@/components/member/raiseDepositTicketGateway.vue";
import getinboxlist from "@/components/member/getInboxList.vue";
import adjustmember from "@/components/member/adjustMember.vue";
import adjustvoucherbalance from "@/components/member/adjustVoucherBalance.vue";
import freegametoken from "@/components/member/freeGameToken.vue";
import upsertlabel from "@/components/member/upsertLabel.vue";
import bonusissue from "@/components/member/bonusIssue.vue";
import editmember from "@/components/member/editMember.vue";
import gettac from "@/components/member/getTac.vue";
import getbanktac from "@/components/member/getBankTac.vue";
import updatevip from "@/components/member/updateVip.vue";
import promomemberassign from "@/components/member/promoMemberAssign.vue";
import resetpasswordmember from "@/components/member/resetPasswordMember.vue";
import clearoutstanding from "@/components/member/clearOutstanding.vue";
import memberReportContainer from "@/components/operatorTab/memberReportContainer.vue";
import memberLogContainer from "@/components/operatorTab/memberLogContainer.vue";
import ticketdetail from "@/components/ticket/ticketDetail.vue";

import adjustfreebalance from "@/components/member/adjustFreeBalance.vue";
import fundtransferprovider from "@/components/member/fundTransferProvider.vue";
import raisedepositticketvoucher from "@/components/member/raiseDepositTicketVoucher.vue";
import raisedepositticketvouchergateway from "@/components/member/raiseDepositTicketVoucherGateway.vue";
import getvoucherlist from "@/components/member/getVoucherList.vue";
import getmessagelist from "@/components/member/getMessageList.vue";
import freecreditmanualassign from "@/components/member/freeCreditManualAssign.vue";
import issuefreespin from "@/components/member/issueFreeSpin.vue";
import checkmemberfreespin from "@/components/member/checkMemberFreeSpin.vue";
import clearfreecredit from "@/components/member/clearFreeCredit.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    // updatememberbetlimit,
    raisedepositticket,
    raisedepositticketgateway,
    getinboxlist,
    adjustmember,
    freegametoken,
    upsertlabel,
    bonusissue,
    editmember,
    gettac,
    getbanktac,
    updatevip,
    promomemberassign,
    resetpasswordmember,
    clearoutstanding,
    memberReportContainer,
    memberLogContainer,
    ticketdetail,
    adjustfreebalance,
    fundtransferprovider,
    raisedepositticketvoucher,
    raisedepositticketvouchergateway,
    getvoucherlist,
    getmessagelist,
    freecreditmanualassign,
    adjustvoucherbalance,
    issuefreespin,
    checkmemberfreespin,
    clearfreecredit
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "",
    sortType: "desc",
    info: null,
    loginList: [],
    depositList: [],
    voucherDepositList: [],
    withdrawalList: [],
    labelList: [],
    historyList: [],
    validTurnover: null,
    winlose: null,
    wallet: null,
    member: null,
    ftd: null,
    bonusAmount: 0,
    promoID: "",
    bonusName: "",
    promoAccumulate: 0,
    promoTarget: 0,
    promoCriteria: "",
    promoDate: null,
    promoInbox: "",
    promoCampaign: "",
    voucherId: "",
    voucherCash: "",
    promoRemark: "",
    inboxLabel: "",
    campaignLabel: "",
    voucherIdLabel: "",
    voucherCashLabel: "",
    ftdAmount: 0,
    ftdDate: null,
    currentVip: "",
    nextVip: "",
    possibleNextVip: "",
    vipDepositAcc: 0,
    vipDepositTarget: 0,
    vipTurnoverAcc: 0,
    vipTurnoverTarget: 0,
    rewardTypeNext: "",
    csNext: "",
    cashNext: 0,
    spNext: "",
    lastCycle: null,
    nextCycle: null,
    memberLabel: null,
    bankList: [],
    editSelectedMember: null,
    selectedTicketId: null,
    cycleDay: null,
    cycleStatus: false,
    cashBalance: 0,
    gameBalance: 0,
    voucherBalance: 0,
    isUat: config.isUat,
    firstVTab: "normal"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    currentMonth() {
      return this.$moment(new Date).format("MMMM");
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    isViewOnly() {
      return this.$helpers.showActionButton("e_memberlist");
    },
    memberID() {
      return this.$store.getters.selectedMemberID;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_memberlist");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    fundTransferEnable() {
      return config.fundTransferEnable == "1";
    }
  },
  mounted: function() { 
    $("[data-collapse]").each(function() {
      var me = $(this),
        targetSelector = me.data('collapse'),
        target = $(targetSelector);

      // Use `.on('click', ...)` to bind click events
      me.on('click', function() {
        target.collapse('toggle');
        return false;
      });

      // Bind the `shown.bs.collapse` event to update the icon when the target is shown
      target.on('shown.bs.collapse', function() {
        me.html('<i class="fas fa-minus"></i>');
      });

      // Bind the `hidden.bs.collapse` event to update the icon when the target is hidden
      target.on('hidden.bs.collapse', function() {
        me.html('<i class="fas fa-plus"></i>');
      });
    });
    
    if(this.$store.getters.sessionToken) {
      this.getMemberSummary();
      setTimeout(() => {
        if(this.$refs.memberReportContainer) {
          this.$refs.memberReportContainer.refresh('dailystatement');
        }
        if(this.$refs.memberLogContainer) {
          this.$refs.memberLogContainer.refresh('adjustmentlog');
        }
      }, 300);
    }

    if (this.$route.query.reportTab) {
      var cat = this.$route.query.reportTab

      var jumpreport = ''
      switch(cat) {
        case 'slots':
          if(this.showActionButton('gameresultslots'))
            jumpreport = 'gameresultslots'
          break;
        case 'livecasino':
          if(this.showActionButton('gameresultlivecasino'))
            jumpreport = 'gameresultlivecasino'
          break;
        case 'sportsbook':
          if(this.showActionButton('gameresultsportsbook'))
            jumpreport = 'gameresultsportsbook'
          break;
        case 'cockfight':
          if(this.showActionButton('gameresultcockfight'))
            jumpreport = 'gameresultcockfight'
          break;
        case 'rescue':
          if(this.showActionButton('gameresultrescue'))
            jumpreport = 'gameresultrescue'
          break;
        case 'reward':
          if(this.showActionButton('gameresultreward'))
            jumpreport = 'gameresultreward'
          break;
        case 'freeslots':
          if(this.showActionButton('gameresultfreeslots'))
            jumpreport = 'gameresultfreeslots'
          break;
        case 'others':
          if(this.showActionButton('gameresultothers'))
            jumpreport = 'gameresultothers'
          break;
      }

      if(jumpreport != '') {
        setTimeout(() => {
          this.jumpToMemberReport(jumpreport)
        }, 300);
      }
    }
  },
  methods: {
    jumpToMemberReport(cat) {
      var vm = this;

      $(document).ready(function(){
        if(document.getElementById('memberReportContainer') != null) {
          document.getElementById('memberReportContainer').scrollIntoView({
            behavior: 'smooth'
          });
          vm.$refs.memberReportContainer.refresh(cat);
        }
      });
    },
    getTextColor(backgroundColor) {
      if (!backgroundColor) return '#000000'; // Default to black if no color provided
      // Convert hex color to RGB
      const rgb = backgroundColor.replace('#', '').match(/.{1,2}/g).map((hex) => parseInt(hex, 16));
      // Calculate relative luminance
      const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
      return luminance > 0.5 ? '#000000' : '#ffffff'; // Black for light backgrounds, white for dark
    },
    showHideTab(cat) {
      var list = []
      if(cat == 'report') {
        list = ['dailystatement', 'platformwinlose' , 'providerwinlosemember',
                    'refereelist', 'rebatemember', 'gameresultslots' , 'gameresultlivecasino',
                    'gameresultsportsbook', 'gameresultcockfight' , 'gameresultrescue' , 'gameresultreward'
                    , 'gameresultfreeslots', 'gameresultothers', 'pendingbetlistwbet', 'pendingbetlist9w', 'pendingbetlistothers', 'memberlinkage'
        ]
      } else {
        list = ['adjustmentlog', 'bonuslog' , 'memberloginlog',
                    'resultchangeslog', 'viplog', 'tokenlog', 'adjustfreebalancelog', 'memberlog', 'membersosclicklog', 'memberwalletvoucherlog', 'clearoutstandinglog',
                    'freespinlog', 'membervoucherredeemedlog'
        ]
      }
      var displayTab = false;

      for(var i = 0; i < list.length; i++) {
        if(this.$helpers.showActionButton(list[i]))
          displayTab = true
      }
      return displayTab
    },
    jumpToRLReport() {
      var vm = this;
      $(document).ready(function(){
        if(document.getElementById('memberReportContainer') != null) {
          document.getElementById('memberReportContainer').scrollIntoView({
            behavior: 'smooth'
          });
          vm.$refs.memberReportContainer.refresh('refereelist');
        }
      });
    },
    jumpToLoginLog(ip) {
      var vm = this;
      $(document).ready(function(){
        if(document.getElementById('memberLogContainer') != null) {
          document.getElementById('memberLogContainer').scrollIntoView({
            behavior: 'smooth'
          });
          var json = {
            login_ip: ip
          };
          vm.$store.dispatch("user/setLoginLogParam", json);
          vm.$refs.memberLogContainer.refresh('memberloginlog');
        }
      });
    },
    getTicketDetail: function(e) {
      this.selectedTicketId = e.ticket_id;
      this.$refs.ticketdetail.$refs.ticketDetail.show();
    },
    showTicketDetails(e) {
      return this.$t("ui.ticket_id") + ": " + e.ticket_id + " " + this.$t("ui.ticket_amount") + ": " + e.ticket_amount + " " + this.$t("ui.bonus_amount") + ": " + e.bonus_amount;
    },
    clearInfo() {
      this.loginList = [];
      this.depositList = [];
      this.voucherDepositList = [];
      this.withdrawalList = [];
      this.labelList = [];
      this.historyList = [];
      this.validTurnover = null;
      this.winlose = null;
      this.wallet = null;
      this.member = null;
      this.ftd = null;
      this.bonusAmount = 0;
      this.promoID = "";
      this.bonusName = "";
      this.promoAccumulate = 0;
      this.promoTarget = 0;
      this.promoCriteria = "";
      this.promoDate = null;
      this.promoInbox = "";
      this.promoCampaign = "";
      this.voucherId = "";
      this.voucherCash = "";
      this.promoRemark = "";
      this.inboxLabel = "";
      this.campaignLabel = "";
      this.voucherIdLabel = "";
      this.voucherCashLabel = "";
      this.ftdAmount = 0;
      this.ftdDate = null;
      this.currentVip = "";
      this.nextVip = "";
      this.possibleNextVip = "";
      this.vipDepositAcc = 0;
      this.vipDepositTarget = 0;
      this.vipTurnoverAcc = 0;
      this.vipTurnoverTarget = 0;
      this.rewardTypeNext = "";
      this.csNext = "";
      this.cashNext = 0;
      this.spNext = "";
      this.lastCycle = null;
      this.nextCycle = null;
      this.memberLabel = null;
      this.bankList = [];
      this.cycleDay = null;
      this.cashBalance = 0;
      this.gameBalance = 0;
      this.voucherBalance = 0;
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    getMemberSummary: function() {
      let url = config.memberSummaryV2Url();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.memberID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearInfo()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.info = response.data.ds;
                if (this.info != null) {
                  if (response.data.ds.summary) {
                    if(response.data.ds.summary.length > 0) {
                      this.validTurnover = response.data.ds.summary[0].valid_turnover;
                      this.winlose = response.data.ds.summary[0].winlose;
                    }
                  }

                  if(response.data.ds.deposit)
                    this.depositList = response.data.ds.deposit;

                  if(response.data.ds.voucherdeposit)
                    this.voucherDepositList = response.data.ds.voucherdeposit

                  if (response.data.ds.withdrawal)
                    this.withdrawalList = response.data.ds.withdrawal;

                  if (response.data.ds.history)
                    this.historyList = response.data.ds.history;

                  if (response.data.ds.login)
                    this.loginList = response.data.ds.login;

                  if (response.data.ds.details) {
                    if (response.data.ds.details.length > 0)
                      this.member = response.data.ds.details[0];
                  }

                  if (response.data.ds.wallet) {
                    if (response.data.ds.wallet.length > 0)
                      this.wallet = response.data.ds.wallet[0];
                  }

                  if (response.data.ds.ftd) {
                    if (response.data.ds.ftd.length > 0)
                      this.ftd = response.data.ds.ftd[0];
                      if (this.ftd != null) {
                        this.ftdAmount = this.ftd.ftd_amount;
                        this.ftdDate = this.ftd.ftd_date;
                      }
                  }

                  if (response.data.ds.promo) {
                    if(response.data.ds.promo.length > 0) {
                      var promoType = response.data.ds.promo[0].a;
                      if (promoType == "TURNOVER") {
                        this.promoAccumulate = response.data.ds.promo[0].d;
                        this.promoTarget = response.data.ds.promo[0].b;
                        this.promoID = response.data.ds.promo[0].e;
                        this.bonusName = response.data.ds.promo[0].g;
                        this.bonusAmount = response.data.ds.promo[0].h;
                        this.promoDate = response.data.ds.promo[0].i;
                        this.promoCriteria = promoType;
                      } else if (promoType == "WIN") {
                        this.promoAccumulate = response.data.ds.promo[0].c;
                        this.promoTarget = response.data.ds.promo[0].b;
                        this.promoID = response.data.ds.promo[0].e;
                        this.bonusName = response.data.ds.promo[0].g;
                        this.bonusAmount = response.data.ds.promo[0].h;
                        this.promoDate = response.data.ds.promo[0].i;
                        this.promoCriteria = promoType;
                      }
                      if(response.data.ds.promo[0].j) {
                        const j = response.data.ds.promo[0].j;

                        this.promoInbox = null;
                        this.promoCampaign = null;
                        this.voucherId = null;
                        this.voucherCash = null;
                        this.promoRemark = null;
                        this.inboxLabel = null;
                        this.campaignLabel = null;
                        this.voucherIdLabel = null;
                        this.voucherCashLabel = null;

                        if (j.includes(":")) {
                          const pairs = j.split(",");

                          pairs.forEach(pair => {
                            const [rawKey, rawValue] = pair.split(":");

                            if (!rawKey || !rawValue) return;

                            const key = rawKey.trim().toUpperCase();
                            const value = rawValue.trim();

                            switch (key) {
                              case "inbox_id":
                                this.inboxLabel = key;
                                this.promoInbox = value;
                                break;
                              case "campaign":
                                this.campaignLabel = key;
                                this.promoCampaign = value;
                                break;
                              case "voucher_id":
                                this.voucherIdLabel = key;
                                this.voucherId = value;
                                break;
                              case "voucher_cash":
                                this.voucherCashLabel = key;
                                this.voucherCash = value;
                                break;
                              default:
                                // fallback if unexpected key
                                this.promoRemark = j;
                            }
                          });

                        } else {
                          this.promoRemark = j;
                        }
                      }
                    }
                  }

                  if (response.data.ds.bank)
                    this.bankList = response.data.ds.bank;

                  if (response.data.ds.label) {
                    this.labelList = response.data.ds.label;
                    var arr = [];
                    response.data.ds.label.forEach(value => {
                      arr.push(value["label_name"]);
                    });

                    this.memberLabel = arr.toString();
                  }

                  if (response.data.ds.vip) {
                    if(response.data.ds.vip.length > 0) {
                      if (response.data.ds.vip[0].deposit_next) {
                        var cycle_deposit = response.data.ds.vip[0].cycle_deposit ? response.data.ds.vip[0].cycle_deposit : 0;
                        var starting_deposit = response.data.ds.vip[0].starting_deposit ? response.data.ds.vip[0].starting_deposit : 0;
                        this.vipDepositAcc = cycle_deposit + starting_deposit;
                        this.vipDepositTarget = response.data.ds.vip[0].deposit_next ? response.data.ds.vip[0].deposit_next : 0;
                      }

                      if (response.data.ds.vip[0].turnover_next) {
                        var cycle_turnover = response.data.ds.vip[0].cycle_turnover ? response.data.ds.vip[0].cycle_turnover : 0;
                        var starting_turnover = response.data.ds.vip[0].starting_turnover ? response.data.ds.vip[0].starting_turnover : 0;
                        this.vipTurnoverAcc = cycle_turnover + starting_turnover;
                        this.vipTurnoverTarget = response.data.ds.vip[0].turnover_next ? response.data.ds.vip[0].turnover_next : 0;
                      }

                      this.currentVip = response.data.ds.vip[0].vip_name;
                      this.nextVip = response.data.ds.vip[0].vip_name_next;
                      this.possibleNextVip = response.data.ds.vip[0].possible_vip_name_next;
                      this.lastCycle = response.data.ds.vip[0].last_cycle;
                      this.nextCycle = response.data.ds.vip[0].next_cycle;

                      
                    }
                  }

                  // loginStreak
                  if (response.data.ds.loginstreak) {
                    if(response.data.ds.loginstreak.length > 0) {
                      this.cycleDay = response.data.ds.loginstreak[0].cycle
                      this.cycleStatus = response.data.ds.loginstreak[0].status
                    }
                  }

                  // freewallet
                  if (response.data.ds.freewallet) {
                    if(response.data.ds.freewallet.length > 0) {
                      this.gameBalance = response.data.ds.freewallet[0].game_balance
                      this.cashBalance = response.data.ds.freewallet[0].cash_balance
                    }
                  }

                  // voucher
                  if (response.data.ds.voucher) {
                    if(response.data.ds.voucher.length > 0) {
                      this.voucherBalance = response.data.ds.voucher[0].cash_balance
                    }
                  }
                } else {
                  this.clearInfo()
                }
              } else {
                this.clearInfo()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUnblock: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.unblock"),
          text: this.$t("message.unblock_member_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnblock(item);
          }
        });
    },
    confirmUnblock: function(item) {
      let url = config.memberUnblockUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: item.account_id
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.status = "ACTIVE";
                this.$helpers.showDialog(this.$t("ui.unblock_member"), this.$t("message.success"), "success");
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedMemberStatus: function(member, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_member_status_confirm", { name: member.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMemberStatus(member, eventStatus);
          } else {
            this.getMemberSummary();
          }
        });
    },
    confirmMemberStatus: function(member, status) {
      let url = config.memberStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: member.account_id,
        new_status: status,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                member.status = status;
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getMemberSummary();
              }
            }
          } catch (error) {
            this.loading = false;
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedBankMbmStatus: function(item, eventStatus) {
      if (item.category == '' || item.category == null) {
        eventStatus.srcElement.checked = !item.status;
        item.status = !item.status;
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.invalidCategory"), "error");
        return;
      }

      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_bank_account_status_confirm", { name: item.bank_acc_no }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBankMbmStatus(item, eventStatus.srcElement.checked);
            // alert("Working in progress...");
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmBankMbmStatus: function(item, status) {
      let url = "";
      url = config.bankMemberStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.memberID,
        bank_id: item.bank_id,
        bank_acc_no: item.bank_acc_no,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.status = status;
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                item.status = !item.status;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onPromoSignupAssign: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.free_credit"),
          text: this.$t("message.assign_free_credit_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPromoSignupAssign(item);
          }
        });
    },
    confirmPromoSignupAssign: function(item) {
      let url = config.promotionSignupAssignUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: item.account_id,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getMemberSummary();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUpsertLabel(e) {
      this.editSelectedMember = e;
      this.$refs.upsertlabel.$refs.upsertLabel.show();
    },
    onAdjust(e) {
      this.editSelectedMember = e;
      this.editSelectedMember.wallet = this.wallet
      this.$refs.adjustmember.$refs.adjustMember.show();
    },
    onAdjustVoucherBalance(e) {
      this.editSelectedMember = e;
      this.editSelectedMember.voucher_balance = this.voucherBalance
      this.$refs.adjustvoucherbalance.$refs.adjustVoucherBalance.show();
    },
    onFreeAdjust(e) {
      this.editSelectedMember = e;
      this.$refs.adjustfreebalance.$refs.adjustFreeBalance.show();
    },
    onFreeGameToken(e) {
      this.editSelectedMember = e;
      this.$refs.freegametoken.$refs.freeGameToken.show();
    },
    onFTProvider(e) {
      this.editSelectedMember = e;
      this.editSelectedMember.wallet = this.wallet
      this.$refs.fundtransferprovider.$refs.fundTransferProvider.show();
    },
    // onUpdateMemberBetLimit(e) {
    //   this.editSelectedMember = e;
    //   this.$refs.updatememberbetlimit.$refs.updateMemberBetLimit.show();
    // },
    onFreeCreditManualAssign(e) {
      this.editSelectedMember = e;
      this.$refs.freecreditmanualassign.$refs.freeCreditManualAssign.show();
    },
    onClearFreeCredit(e) {
      this.editSelectedMember = e;
      this.$refs.clearfreecredit.$refs.clearFreeCredit.show();
    },
    onRaiseDepositTicket(e) {
      this.editSelectedMember = e;
      this.$refs.raisedepositticket.$refs.raiseDepositTicket.show();
    },
    onRaiseDepositTicketGateway(e) {
      this.editSelectedMember = e;
      this.$refs.raisedepositticketgateway.$refs.raiseDepositTicketGateway.show();
    },
    onRaiseDepositTicketVoucher(e) {
      this.editSelectedMember = e;
      this.$refs.raisedepositticketvoucher.$refs.raiseDepositTicketVoucher.show();
    },
    onRaiseDepositTicketVoucherGateway(e) {
      this.editSelectedMember = e;
      this.$refs.raisedepositticketvouchergateway.$refs.raiseDepositTicketVoucherGateway.show();
    },
    onGetInbox(e) {
      this.editSelectedMember = e;
      this.$refs.getinboxlist.$refs.getInboxList.show();
    },
    onGetVoucher(e) {
      this.editSelectedMember = e;
      this.$refs.getvoucherlist.$refs.getVoucherList.show();
    },
    onGetMessage(e) {
      this.editSelectedMember = e;
      this.$refs.getmessagelist.$refs.getMessageList.show();
    },
    onBonusIssue(e) {
      this.editSelectedMember = e;
      this.$refs.bonusissue.$refs.bonusIssue.show();
    },
    onPromoMemberAssign(e) {
      this.editSelectedMember = e;
      this.$refs.promomemberassign.$refs.promoMemberAssign.show();
    },
    onEdit(e) {
      this.editSelectedMember = e;
      this.$refs.editmember.$refs.editMember.show();
    },
    onGetTac(e) {
      this.editSelectedMember = e;
      this.$refs.gettac.$refs.getTac.show();
    },
    onResetPasswordMember(e) {
      this.editSelectedMember = e;
      this.$refs.resetpasswordmember.$refs.resetPasswordMember.show();
    },
    onGetBankTac(e) {
      this.editSelectedMember = e;
      this.$refs.getbanktac.$refs.getBankTac.show();
    },
    onUpdateVip(e) {
      this.editSelectedMember = e;
      this.$refs.updatevip.$refs.updateVip.show();
    },
    onClearOutstanding(e) {
      this.editSelectedMember = e;
      this.$refs.clearoutstanding.$refs.clearOutstanding.show();
    },
    onIssueFreeSpin(e) {
      this.editSelectedMember = e;
      this.$refs.issuefreespin.$refs.issueFreeSpin.show();
    },
    onCheckMemberFreeSpin(e) {
      this.editSelectedMember = e;
      this.$refs.checkmemberfreespin.$refs.checkMemberFreeSpin.show();
    },
    afterUpsertLabel: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.edit_label"), this.$t("message.success"), "success");
    },
    afterResetPasswordMember: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.reset_password"), this.$t("message.success"), "success");
    },
    afterAdjustMember: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.adjust_member"), this.$t("message.success"), "success");
    },
    afterAdjustVoucherBalance: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.adjust_voucher_balance"), this.$t("message.success"), "success");
    },
    afterFreeGameToken: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.add_free_game_token"), this.$t("message.success"), "success");
    },
    afterFreeAdjust: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.adjust_free_balance"), this.$t("message.success"), "success");
    },
    // afterUpdateMemberBetLimit: function() {
    //   this.getMemberList();
    //   this.$helpers.showDialog(this.$t("ui.combine.update_member_bet_limit"), this.$t("message.success"), "success");
    // },
    afterRaiseDepositTicket: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.raise_deposit_ticket"), this.$t("message.success"), "success");
    },
    afterRaiseDepositTicketGateway: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.raise_deposit_ticket_gateway"), this.$t("message.success"), "success");
    },
    afterRaiseDepositTicketVoucher: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.raise_deposit_ticket_voucher"), this.$t("message.success"), "success");
    },
    afterRaiseDepositTicketVoucherGateway: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.raise_deposit_ticket_voucher_gateway"), this.$t("message.success"), "success");
    },
    afterIssueBonus: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.bonus_issue"), this.$t("message.success"), "success");
    },
    afterPromoMemberAssign: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.promo_member_assign"), this.$t("message.success"), "success");
    },
    afterEditMember: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.edit_member"), this.$t("message.success"), "success");
    },
    afterUpdateVip: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.update_vip"), this.$t("message.success"), "success");
    },
    afterClearOutstanding: function(amt) {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.clear_outstanding"), this.$t("message.successful_clear_outstanding", { amt: this.$n(amt, 'currency') }), "success");
    },
    afterFTProvider: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.fund_transfer_provider"), this.$t("message.success"), "success");
    },
    afterFreeCreditManualAssign: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.free_credit_manual_assign"), this.$t("message.success"), "success");
    },
    afterIssueFreeSpin: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.issue_free_spin"), this.$t("message.success"), "success");
    },
    afterClearFreeCredit: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.clear_free_credit"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
  }
};
</script>
